import styled from 'styled-components'

export const SearchRegion = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  height: 60vh;
  min-height: 0;
`

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
`

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const ROW_GRID = `
  display: grid;
  grid-template-columns: 2rem minmax(0, 16rem) minmax(0, 1fr) 3.5rem;
  align-items: center;
  column-gap: 0.5rem;
  padding: 0 0.5rem;
`

export const TableHeaderRow = styled.div`
  ${ROW_GRID}
  height: 1.875rem;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted-foreground);
  border-bottom: 1px solid var(--border);
`

export const UnitHeaderCell = styled.span`
  text-align: right;
`

export const TagRowButton = styled.button`
  ${ROW_GRID}
  width: 100%;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  color: var(--foreground);

  &:hover {
    background: var(--muted);
  }

  &:focus-visible {
    outline: none;
    background: var(--muted);
    box-shadow: inset 0 0 0 2px var(--ring);
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

export const CellText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
`

export const DescriptionText = styled(CellText)`
  color: var(--muted-foreground);
`

export const UnitText = styled(CellText)`
  text-align: right;
  color: var(--muted-foreground);
  font-size: 0.6875rem;
`

export const ListRegion = styled.div`
  flex: 1;
  min-height: 0;
`

export const StatusLine = styled.div`
  padding: 1rem 0.5rem;
  font-size: 0.75rem;
  color: var(--muted-foreground);
`
